export enum WorkflowType {
  STANDARD = "standard",
  RFE = "rfe",
  NOIR_NOID = "noir_noid"
}

export const RFE_WORKFLOW_OPTION = "RFE";
export const NOIR_NOID_WORKFLOW_OPTION = "NOID/NOIR";

export const getWorkflowType = (
  workflowType?: WorkflowType | string | null,
  isRfe = false
): WorkflowType => {
  if (workflowType === WorkflowType.NOIR_NOID) return WorkflowType.NOIR_NOID;
  if (workflowType === WorkflowType.RFE) return WorkflowType.RFE;
  return isRfe ? WorkflowType.RFE : WorkflowType.STANDARD;
};

export const isRfeLikeWorkflow = (
  workflowType?: WorkflowType | string | null,
  isRfe = false
) => getWorkflowType(workflowType, isRfe) !== WorkflowType.STANDARD;

export const isNoirNoidWorkflow = (
  workflowType?: WorkflowType | string | null
) => getWorkflowType(workflowType) === WorkflowType.NOIR_NOID;
